import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type {
  ImportBlankProductsMutationRequest,
  ImportBlankProductsMutationResponse,
} from "../types/ImportBlankProducts"

type ImportBlankProductsClient = typeof client<
  ImportBlankProductsMutationResponse,
  Error,
  ImportBlankProductsMutationRequest
>
type ImportBlankProducts = {
  data: ImportBlankProductsMutationResponse
  error: Error
  request: ImportBlankProductsMutationRequest
  pathParams: never
  queryParams: never
  headerParams: never
  response: Awaited<ReturnType<ImportBlankProductsClient>>
  client: {
    parameters: Partial<Parameters<ImportBlankProductsClient>[0]>
    return: Awaited<ReturnType<ImportBlankProductsClient>>
  }
}
/**
 * @summary Import blank products
 * @link /v1/product/import-blank-products
 */
export function useImportBlankProducts(
  options: {
    mutation?: UseMutationOptions<
      ImportBlankProducts["response"],
      ImportBlankProducts["error"],
      ImportBlankProducts["request"]
    >
    client?: ImportBlankProducts["client"]["parameters"]
  } = {}
): UseMutationResult<
  ImportBlankProducts["response"],
  ImportBlankProducts["error"],
  ImportBlankProducts["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    ImportBlankProducts["response"],
    ImportBlankProducts["error"],
    ImportBlankProducts["request"]
  >({
    mutationFn: async (data) => {
      const res = await client<
        ImportBlankProducts["data"],
        ImportBlankProducts["error"],
        ImportBlankProducts["request"]
      >({
        method: "post",
        url: `/v1/product/import-blank-products`,
        data,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
